import { ImportAppleContacts } from '@features/client/components/ImportAppleContacts';
import { ContactPicker } from '@shared/components/ContactPicker';
import { Divider, Stack, Typography, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const ImportContactsSection = () => {
  return (
    <>
      <Divider sx={{ marginY: '30px' }} />
      <Stack spacing={2}>
        <Typography variant="body2">
          <FormattedMessage
            id="myProfile.importText"
            defaultMessage="Zde můžete provést hromadný import kontaktů pouze české tel. kontakty. Následně je budete moci editovat před uložením."
          />
        </Typography>
        <Grid container rowSpacing={2}>
          <ContactPicker />
        </Grid>
        <Grid container rowSpacing={2} gap={2}>
          <ImportAppleContacts />
        </Grid>
      </Stack>
    </>
  );
};
export default ImportContactsSection;
